import React, { Component } from "react";
import { Chart } from "primereact/chart";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { connect } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { dashboardActions, mappingActions } from "../actions";
import tableRequest from "../models/tableRequest.js";
import "./Sidebar.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.state = {
       localTransactions: [],
      globalFilter: null,
      first: 0,
      rows: 5,
      totalRecords: 0,
      sortOrder: "",
      loading: false,
    };
    this.state = {
      globalFilter: null,
    };
  }

  componentDidMount() {
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        }
      }
    }
    this.setState({ localTransactions: this.props.todayTransactions });
    this.props.fetchApi(this.tblResponse);
    //this.props.fetchMappingApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {

  
    
    if (this.props.MappingData) {
      if (prevProps.MappingData !== this.props.MappingData) {
        // this.props.myProp has a different value
        if (this.props.MappingData) {
          var e = this.props.MappingData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }

    if (prevProps.MaxFromNo !== this.props.MaxFromNo) {
      this.setState({
        FromNo: this.props.MaxFromNo,
      });
    }
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  onPage(event) {
    //imitate delay of a backend call
    this.getLazyLoadingValues(event);
    //this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }
  render() {
    const chartdata = {
      labels: this.props.Months,
      datasets: [
        {
          label: "Product Mapping",
          data: this.props.MappingChart,
          fill: false,
          borderColor: "#4bc0c0",
        },
        {
          label: "Product De-Mapping",
          data: this.props.DeMappingChart,
          fill: false,
          borderColor: "#9bc0c9",
        },
      ],
    };

   const { localTransactions } = this.state;
    return (
      <main className="mb4">
        <div className="box-shadowe box-space">
          <div
            className="row no-gutters 
          row-cols-1 
          row-cols-md-2 
          row-cols-xl-3
          main-point"
          >
            <a href="activation/issue-number">
              <div className="col toyoBoxDash">
                <div className="card radius-10 border-start  border-info box-side1">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Number Issues</p>
                        <h2 className="my-1 text-info">
                          {" "}
                          {this.props.TotalIssue ? this.props.TotalIssue : 0}
                        </h2>
                      </div>
                      <div className=" box1 widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto">
                        <i className="fa fa-list-ol" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href=" transactions/mapping">
              <div className="col toyoBoxDash ">
                <div className="card radius-10 border-start  border-danger box-side2">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Mapping</p>
                        <h2 className="my-1 text-danger">
                          {" "}
                          {this.props.TotalMapping
                            ? this.props.TotalMapping
                            : 0}
                        </h2>
                      </div>
                      <div className=" box1 widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto">
                        <i className="fa fa-cube" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href="/transactions/de-mapping">
              <div className="col toyoBoxDash">
                <div className="card radius-10 border-start  border-success box-side3">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">De Mapping</p>
                        <h2 className="my-1 text-success">
                          {" "}
                          {this.props.TotalDeMapping
                            ? this.props.TotalDeMapping
                            : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto">
                        <i className="fa fa-cubes" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <br />

          <div
            className="row no-gutters 
          row-cols-1 
          row-cols-md-2 
          row-cols-xl-3 
          main-point"
          >
            <a href="masters/user-approval">
              <div className="col toyoBoxDash">
                <div className="card radius-10 border-start  border-danger box-side2">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">
                          User Approval Pending{" "}
                        </p>
                        <h2 className="my-1 text-danger">
                          {" "}
                          {this.props.UserPendingApprovel
                            ? this.props.UserPendingApprovel
                            : 0}
                        </h2>
                      </div>
                      <div className=" box1 widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto">
                        <i className="fa fa-user" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>

            <a href="transactions/damage">
              <div className="col toyoBoxDash">
                <div className="card radius-10 border-start  border-warning box-side4">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-secondary">Damage</p>
                        <h2 className="my-1 text-warning">
                          {this.props.TotalDamage ? this.props.TotalDamage : 0}
                        </h2>
                      </div>
                      <div className="box1 widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto">
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <div className="col toyoBoxDash">
              <div className="card radius-10 border-start  border-warning box-side5">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div>
                      <p className="mb-0 text-secondary">Total Scans</p>
                      <h2 className="my-1 text-primary">
                        {this.props.TotalScans ? this.props.TotalScans : 0}
                      </h2>
                    </div>
                    <div className="box1 widgets-icons-2 rounded-circle bg-gradient-primary text-white ms-auto">
                      <i className="fa fa-qrcode" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <a href="/transactions/damage"></a>
        <div className="row m-top">
          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Top Product Scans</h2>
              
              <Chart

                type="doughnut"
                data={{
                  labels: this.props.ProductNames,
                  datasets: [
                    {
                      // label: "Products",
                      data: this.props.ScanCounts,
                      backgroundColor: [
                        "#a86464",
                        "#98d1d1",
                        "#3c4e4b",
                        "#e27c7c",
                        "#d2980d",
                        "#df979e",
                        "#d7658b",
                        "#c80064",
                      ],
                      hoverOffset: 4,
                    },
                  ],
                }}
              />
            </div>
          </div>
          <div className="col-md-6 boxx">
            <div className="cards">
              <h2>Product Mappings</h2>
              <Chart
                type="bar"
                data={{
                  labels: this.props.Months,
                  datasets: [
                    {
                      label: "Mappings",
                      data: this.props.MappingChart,
                      backgroundColor: [
                        "#e27c7c",
                        "#a86464",
                        "#6d4b4b",
                        "#503f3f",
                        "#333333",
                        "#3c4e4b",
                        "#466964",
                        "#599e94",
                        "#6cd4c5",
                        "#54bebe",
                        "#76c8c8",
                      ],
                      borderColor: [
                        "#e27c7c",
                        "#a86464",
                        "#6d4b4b",
                        "#503f3f",
                        "#333333",
                        "#3c4e4b",
                        "#466964",
                        "#599e94",
                        "#6cd4c5",
                        "#54bebe",
                        "#76c8c8",
                      ],
                      borderWidth: 1,
                    },
                  ],
                }}
              />
            </div>
          </div>

<div className="  mx-auto p-4" style={{width:"100%"}}>
  <div className="flex flex-wrap md:flex-nowrap -mx-2">
    {/* Left Panel - Transactions Table */}
    <table className="w-100 mb-3">
      <tr>
        <td>  <div className="w-full md:w-7/12 p-4" style={{ backgroundColor: "white"}}>
        <div className="d-flex justify-content-between align-items-center">
      <h2 className="text-xl font-bold ">Today's Last 15 Transactions</h2>
    
   
        <h6 className="text-lg font-semibold" >Today Total Transactions: <b>{this.props.TodayTnx ? this.props.TodayTnx : 0}
  </b>      </h6>
     
    </div>
      {this.props.TodayTransactions?.length > 0 ? (
        <table className="table-auto w-100 border-collapse border border-gray-300" style={{fontSize:'14px'}}>
          <thead>
            <tr className="bg-gray-200" style={{backgroundColor:'#e5e5e5'}}>
              <th className="border border-gray-300 px-4 py-2 w-1/5 text-center" style={{fontSize:'14px', fontWeight:'500'}}>Unique Request No</th>
              <th className="border border-gray-300 px-4 py-2 w-1/5 text-center" style={{fontSize:'14px', fontWeight:'500'}}>Payment Mode</th>
              <th className="border border-gray-300 px-4 py-2 w-1/5 text-center" style={{fontSize:'14px', fontWeight:'500'}}>Beneficiary</th>
              <th className="border border-gray-300 px-4 py-2 w-1/5 text-center" style={{fontSize:'14px', fontWeight:'500'}}>Amount</th>
              <th className="border border-gray-300 px-4 py-2 w-1/5 text-center" style={{fontSize:'14px', fontWeight:'500'}}>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.props.TodayTransactions.map((item, index) => (
              <tr key={index}>
                <td className="border border-gray-300 px-4 py-2 text-center">{item.UniqueRequestNumber}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">{item.PaymentMode}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">{item.BeneficiaryName}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">{item.Amount}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">{item.Status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500">No transactions found for today.</p>
      )}
    </div></td>
   
      </tr>
    </table>
  
<p style={{fontSize:'14px', fontWeight:'500'}}>"Note: These transactions are shown from the EaseBuzz response."</p>
     
  </div>
</div>



        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state.dashboard?.items?.TodayTransactions);
  return {
    DashboardList: state.dashboard?.items?.DashboardListData,
    TotalMapping: state.dashboard?.items?.DashboardCount?.TotalMapping,
    TotalDeMapping: state.dashboard?.items?.DashboardCount?.TotalDeMapping,
    UserPendingApprovel:state.dashboard?.items?.DashboardCount?.UserPendingApprovel,
    TotalDamage: state.dashboard?.items?.DashboardCount?.TotalDamage,
    TodayTnx:state.dashboard?.items?.DashboardCount?.TodayTnx,
    TotalScans: state.dashboard?.items?.DashboardCount?.TotalScans,
    TotalIssue: state.dashboard?.items?.DashboardCount?.TotalIssue,
    DeMappingChart: state.dashboard?.items?.DeMappingList,
    MappingChart: state.dashboard?.items?.MappingList,
    ProductNames: state.dashboard?.items?.ProductNames,
    ScanCounts: state.dashboard?.items?.ScanCounts,
    Months: state.dashboard?.items?.MonthName,
    MappingData: state.mapping.items,
    TodayTransactions: state.dashboard?.items?.TodayTransactions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(dashboardActions.fetchData(obj));
    },
    fetchMappingApi: (obj) => {
      dispatch(mappingActions.getAll(obj));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
